import { Layout } from 'antd';
import React from 'react';
import AuthSidebar from '../components/AuthSidebar/AuthSidebar';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

const { Content } = Layout;

const AuthLayout = () => {
    return (
        <Layout className='layout'>
            <AuthSidebar />
            <Layout>
                <Content className='auth-content'>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default AuthLayout;
